export default {
  title: 'Notice',
  centerTitle: 'Pending Item',
  pendingCount: 'Pending notices',
  normalNotice: 'Normal',
  importantNotice: 'Important',
  criticalNotice: 'Critical',
  noticeTypeAnnouncement: 'Announcement',
  noticeTypeDataOverwrite: 'Data overwrite',
  noticeTypeUpgrade: 'System upgrade',
  noticeTypeVote: 'Vote',
  noticeTypeSurvey: 'Survey',
  noticeTypeResearch: 'Research',
  ack: 'Acknowledge',
  applyDelay: 'Apply delay',
  selectDelayTime: 'Please select delay time',
  feedback: 'Feedback',
  feedbackPlaceholder: 'Please enter feedback',
  feedbackRequired: 'Please enter feedback',
  survey: 'Survey',
  answerPlaceholder: 'Please enter your answer',
  answerRequired: 'Please complete all required questions',
  openLink: 'View details',
  submitSuccess: 'Submitted successfully',
  forceShowCloseBlocked: 'This notice is mandatory. Please complete the required action before closing it.'
};
